import { apiConfig } from '../api-config';

// eslint-disable-next-line no-shadow
export enum AnswerType {
  accepted = 'Accepted',
  refused = 'Refused',
  pending = 'Pending'
}

export interface UpdateReportTerm {
  termId: number;
  answer: AnswerType;
  tokenKey: string;
}

export const updateReportTerm = async (params) => {
  return apiConfig
    .patch('/api/TermCommitment/answer', params)
    .then((resp) => resp.data)
    .catch((err) => ({ hasErros: true, message: err.message }));
};
